import { apiGet, apiPatch } from './client';
import type { AssetType, AssetTypeBatchRequest } from '../types/AssetType';

export function getAssetTypes(): Promise<AssetType[]> {
  return apiGet<AssetType[]>('/api/asset-types');
}

export function saveAssetTypesBatch(
  added: AssetType[],
  modified: AssetType[],
  deletedIds: number[],
): Promise<AssetType[]> {
  return apiPatch<AssetTypeBatchRequest, AssetType[]>('/api/asset-types/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
